import React from 'react';
import '../../styles/HeroAboutUs.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS for fonts
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; 

import bgImage from '../../assets/ContactUsBG.webp';
import Privacy from './Privacy'; // Ensure the path is correct

const HeroPrivacy = () => {
  return (
    <>
      <section
        id="hero" className="hero-section-about about-hero-section d-flex align-items-center" 
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: 'cover',
          height:'40vh',
          backgroundPosition: 'center',
        }}
      >
        <div className="overlay"></div>
        <div className="container content-hero content-hero-about ">
          <div className="row hero-about">
            <div className="col-lg-12 col-md-10 col-sm-12 ">
              <div className="text-start hero-desc-about">
                <h1 className="poppins-bold text-light text-center mt-5 about-title-hero">
                  Privacy Policy
                </h1>
                <p className="poppins-regular text-light text-center hero-desc about-description">
                We value your privacy and are committed to protecting your personal information. Please review our Privacy Policy for more details.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Include the other sections */}
      <Privacy />
    </>
  );
};

export default HeroPrivacy;